
var layout = {
    toggleMobileMenu: function () {
        var body = document.getElementsByTagName("body")[0];
        if (body.classList.contains("sidebar-enable")) {
            body.classList.remove("sidebar-enable");
        }
        else {
            body.classList.add("sidebar-enable");
        }
    }
};